import styled, { css } from 'styled-components';

type ContainerProps = {
  isSelected: boolean;
};

export const Container = styled.button<ContainerProps>`
  height: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 9px;
  background-color: ${({ theme }) => theme.colors.background_white};
  color: ${({ theme }) => theme.colors.primary};
  margin: 0.5rem 0.5rem 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 300;

  ${({ isSelected }) =>
    isSelected &&
    css`
      transition: all linear 300ms;
      background-color: ${({ theme }) => theme.colors.primary};
      color: #fff;
      box-shadow: 0px 3px 1px #00000029;
    `}

  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
